(function () {
  if (document.documentElement.dataset.productStylePropertyBound === 'true') return;
  document.documentElement.dataset.productStylePropertyBound = 'true';

  const PROPERTY_NAME = 'Style';
  let pendingStyle = '';

  function isCartAddUrl(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  function getUrl(input) {
    if (typeof input === 'string') return input;
    if (input && input.url) return input.url;
    return '';
  }

  document.addEventListener(
    'click',
    (event) => {
      const host = event.target && event.target.closest && event.target.closest('[data-product-style]');
      pendingStyle = host && host.getAttribute('data-product-style');
      pendingStyle = pendingStyle ? pendingStyle.trim() : '';
    },
    true
  );

  // Single-item { id, quantity } uses root properties. { items: [...] } only
  // keeps properties that are on the item, so a one-item add gets them there.
  function applyStyle(payload) {
    if (!payload || typeof payload !== 'object') return payload;
    if (Array.isArray(payload.items)) {
      if (payload.items.length === 1 && payload.items[0] && typeof payload.items[0] === 'object') {
        if (!payload.items[0].properties) payload.items[0].properties = {};
        if (!payload.items[0].properties[PROPERTY_NAME]) {
          payload.items[0].properties[PROPERTY_NAME] = pendingStyle;
        }
      }
      return payload;
    }
    if (!payload.properties) payload.properties = {};
    if (!payload.properties[PROPERTY_NAME]) payload.properties[PROPERTY_NAME] = pendingStyle;
    return payload;
  }

  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = getUrl(input);
    if (!isCartAddUrl(url) || !pendingStyle || !init || init.body == null) {
      return originalFetch.apply(this, arguments);
    }

    try {
      if (typeof init.body === 'string') {
        const payload = applyStyle(JSON.parse(init.body));
        init = Object.assign({}, init, { body: JSON.stringify(payload) });
      } else if (init.body instanceof FormData && !init.body.get(`properties[${PROPERTY_NAME}]`)) {
        init.body.append(`properties[${PROPERTY_NAME}]`, pendingStyle);
      }
    } catch (error) {
      /* leave the request unchanged */
    }

    pendingStyle = '';
    return originalFetch.call(this, input, init);
  };
})();
